import { Input, Injectable } from "@angular/core";
import { isNullOrEmptyString } from "../../_helpers";


@Injectable()
/**
 * Class legende rang Color
 */
export class LegendColor {
    /**valeur min à afficher en front si pas de title*/
    MinValue: number;
    /**valeur min à afficher en front si pas de title*/
    MaxValue: number;
    Red: number;
    Blue: number;
    Green: number;
    alpha: number;
    /**texte à afficher au rang au lieu du formatage min max*/
    Title: string | undefined;
    /**tooltip formaté à afficher si texte au rang*/
    Tooltip: string | undefined;

    private _color: string;
    @Input()
    set Color(color: string) {
        this._color = color;
    }
    get Color(): string {
        if (this._color)
            return this._color;
        return "rgb(" + Math.round(this.Red)
            + "," + Math.round(this.Green)
            + "," + Math.round(this.Blue) + ")";
    }

    public constructor() {

    }

    /**
     * Initialise deuis une legend color
     * @param _iLegendColor rang
     */
    public Init(_iLegendColor: LegendColor) {
        this.LegendColor();
        this.Blue = _iLegendColor.Blue;
        this.Color = _iLegendColor['_color'];
        this.Green = _iLegendColor.Green;
        this.MaxValue = _iLegendColor.MaxValue;
        this.MinValue = _iLegendColor.MinValue;
        if (!isNullOrEmptyString(_iLegendColor.Title)) {
            this.Title = _iLegendColor.Title;
            this.Tooltip = _iLegendColor.Tooltip;
        }

    }

    public LegendColor() {
        this.MinValue = 0;
        this.MinValue = 0;
        this.Title = undefined;
        this.Tooltip = undefined;
    }

    /**
     * affecte un titre au lieu d afficher min et max
     * et ceux ci revienne en tooltip formaté [min;max]
     * @param _iTitle 
     */
    public ReplaceByText(_iTitle: string) {
        if (!isNullOrEmptyString(_iTitle)) {
            this.Title = _iTitle;
            this.Tooltip = LegendColor.FormatRangTooltip(this);
        }
    }

    /**
     * Format un tooltip sur le rang de legend titre depuis les valeurs
     * @param _iLegendColor 
     * @returns 
     */
    public static FormatRangTooltip(_iLegendColor: LegendColor) {
        return `[${_iLegendColor.MinValue}; ${_iLegendColor.MaxValue}]`
    }

}
